import React from 'react';

export const HEAR_ABOUT_OPTIONS = [
  { value: 'google',     label: 'Google' },
  { value: 'facebook',   label: 'Facebook' },
  { value: 'instagram',  label: 'Instagram' },
  { value: 'tiktok',     label: 'TikTok' },
  { value: 'friend',     label: 'A friend or colleague' },
  { value: 'trade_show', label: 'Trade show / event' },
  { value: 'other',      label: 'Other' },
];

export function HearAboutRadios({ value, onChange, accent = '#0B0B0E', testid = 'embed-hear-about' }) {
  return (
    <div role="radiogroup" data-testid={testid} style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: 8 }}>
      {HEAR_ABOUT_OPTIONS.map((o) => {
        const on = value === o.value;
        return (
          <label
            key={o.value}
            data-testid={`${testid}-${o.value}`}
            style={{
              display: 'flex', alignItems: 'center', gap: 8, padding: '9px 11px', borderRadius: 8, cursor: 'pointer',
              border: `2px solid ${on ? accent : '#e5e7eb'}`, background: on ? `${accent}14` : '#fff',
              fontSize: 13, fontWeight: on ? 700 : 500, color: '#111827', transition: 'border-color .15s, background .15s',
            }}
          >
            <input
              type="radio"
              name={testid}
              value={o.value}
              checked={on}
              onChange={() => onChange(o.value)}
              style={{ width: 16, height: 16, accentColor: accent, margin: 0 }}
            />
            {o.label}
          </label>
        );
      })}
    </div>
  );
}
